import { InputLabel } from "@mui/material";
import PropTypes from "prop-types";
import appcolors from "../../constants/Colors";

const Label = ({ labelText, required, labelProps, htmlFor }) => {
  return (
    <InputLabel
      sx={{
        marginBottom: "5px",
        fontSize: "0.875rem",
        color: appcolors.charcolGrey,
        ...labelProps,
      }}
      htmlFor={htmlFor}
    >
      {labelText}
      {/* {required && <span style={{ color: appcolors.primary }}>*</span>} */}
    </InputLabel>
  );
};

Label.propTypes = {
  labelText: PropTypes.string.isRequired,
  required: PropTypes.bool,
  labelProps: PropTypes.object,
  htmlFor: PropTypes.string,
};

Label.defaultProps = {
  required: false,
  labelProps: {},
  htmlFor: "",
};

export default Label;
